import React from "react";
import { ArrowRight, Check } from "lucide-react";
import { Link } from "react-router-dom";
import { SERVICES } from "../mock";

const SectionLabel = ({ children }) => (
  <div className="flex items-center justify-center gap-2 mb-4">
    <span className="h-px w-6 bg-[#159A90]" />
    <span className="text-[12px] font-bold tracking-[0.16em] text-[#159A90] uppercase">
      {children}
    </span>
    <span className="h-px w-6 bg-[#159A90]" />
  </div>
);

const Services = () => {
  return (
    <section id="services" className="py-20 md:py-28 px-5 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-2xl mx-auto fade-up">
          <SectionLabel>Our Services</SectionLabel>
          <h2 className="font-heading font-extrabold text-[#1B2A4A] text-[32px] md:text-[42px] leading-tight">
            Quality medical care, delivered at the comfort of your home
          </h2>
          <p className="text-[#57616e] mt-4 text-[16px] leading-relaxed">
            A single trusted team for every home care need — from a short nurse visit
            to round-the-clock live-in care. Bridging the gap between hospital
            discharge and full recovery.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-14">
          {SERVICES.map((s, i) => (
            <Link
              to={`/services/${s.slug}`}
              key={s.title}
              className="group block bg-white rounded-[22px] overflow-hidden border border-[#DEE6EE] shadow-[0_8px_24px_rgba(0,0,0,0.04)] hover:shadow-[0_20px_45px_rgba(0,0,0,0.12)] hover:-translate-y-1.5 transition-all duration-300 fade-up"
              style={{ transitionDelay: `${(i % 4) * 60}ms` }}
            >
              <div className="h-44 overflow-hidden">
                <img
                  src={s.img}
                  alt={s.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <h3 className="font-heading font-bold text-[18px] text-[#1B2A4A]">
                  {s.title}
                </h3>
                <p className="text-[14px] text-[#6b7481] mt-2 leading-relaxed min-h-[60px]">
                  {s.desc}
                </p>
                {s.points && (
                  <ul className="mt-3 space-y-1.5">
                    {s.points.map((p) => (
                      <li key={p} className="flex items-center gap-2">
                        <span className="flex items-center justify-center w-4 h-4 rounded-full bg-[#159A90]/12 shrink-0">
                          <Check size={11} className="text-[#159A90]" />
                        </span>
                        <span className="text-[12.5px] text-[#57616e]">{p}</span>
                      </li>
                    ))}
                  </ul>
                )}
                <span className="inline-flex items-center gap-1.5 mt-4 text-[14px] font-semibold text-[#159A90] group-hover:gap-2.5 transition-all">
                  View Details <ArrowRight size={15} />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
